<template>
  <div class="container">
    <v-text-field
      v-model="setting.key"
      :label="$t('general.pump.parameter.key')"
    />
    <v-text-field
      v-model="setting.label"
      :label="$t('general.pump.parameter.label')"
    />
    <v-select
      v-model="setting.type"
      :items="[
        {
          value: 'bool',
          text: 'Boolean',
        },
        {
          value: 'text',
          text: 'Text',
        },
      ]"
      :label="$t('general.pump.parameter.type')"
      :no-data-text="$t('general.forms.no_data_text')"
    />
    <v-text-field
      v-model="setting.unit"
      :label="$t('general.pump.parameter.unit')"
    />
    <v-select
      v-model="setting.formatting"
      :disabled="setting.type !== 'text'"
      :items="[
        {
          value: '0',
          text: '0',
        },
        {
          value: '0.0',
          text: '0.0',
        },
        {
          value: '0.00',
          text: '0.00',
        },
        {
          value: '0.000',
          text: '0.000',
        },
        {
          value: 'unformatted',
          text: 'Text',
        },
      ]"
      :label="$t('general.pump.parameter.formatting')"
      :no-data-text="$t('general.forms.no_data_text')"
    />
    <v-switch
      v-model="setting.visible"
      :label="$t('general.pump.parameter.visible')"
    />
    <v-switch
      v-model="setting.editable"
      :label="$t('general.pump.parameter.editable')"
    />
    <v-btn
      icon
      @click="() => onDecreaseSort(setting.id)"
    >
      <v-icon>keyboard_arrow_up</v-icon>
    </v-btn>
    <v-btn
      icon
      @click="() => onIncreaseSort(setting.id)"
    >
      <v-icon>keyboard_arrow_down</v-icon>
    </v-btn>
    <v-btn
      icon
      @click="() => onDelete(setting.id)"
    >
      <v-icon>delete</v-icon>
    </v-btn>
  </div>
</template>

<script>
export default {
  name: 'PumpParameter',
  props: {
    setting: {
      type: Object,
      required: true,
    },
    onDelete: {
      type: Function,
      required: true,
    },
    onIncreaseSort: {
      type: Function,
      required: true,
    },
    onDecreaseSort: {
      type: Function,
      required: true,
    },
  },
};
</script>

<style scoped>
.container {
  display: grid;
  grid-template-columns: repeat(5, 4fr) repeat(2, 2fr) repeat(3, 1fr);
  gap: 5px;
}
</style>
